<template>
    <div class="lively-resource">
        <div class="resource-search">
            <div class="search-resource flex flex-mid">
                <p>事件类型</p>
                <div class="imitate-select">
                    <div class="imitate-select-cont" @click.stop="isShow = !isShow">
                        <p class="flex-1">{{mediumCont}}</p>
                        <i class="iconfont icon-zheng-triangle" :class="{'recover':isShow}"></i>
                    </div>
                    <div :class="['imitate-select-list',{'imitate-select-list-show':isShow}]">
                        <ul>
                            <li v-for="(val,key,index) in mediumList" :key="index"><a href="javascript:" @click="copyMedium($event,{el:val,key:key})">{{val}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="seaarch-time flex flex-mid">
                <p>时间类型</p>
                <label class="flex flex-mid" :for="item.name" v-for="(item,index) in selectRange" :key="index">
                    <div class="input-box-radio">
                        <input type="radio" name="time" :value="item.id" v-model="rangeVal" :id="item.name">
                        <span></span>
                    </div>
                    <span>{{item.txt}}</span>
                </label>
            </div>
            <div class="search-time-scope flex flex-mid">
                <p>时间范围</p>
                <div class="input-box-date" >
                    <input type="text" id="_laydaystart" name="daystart" readonly="readonly" placeholder="请选择起始时间">
                </div>
                <p>—</p>
                <div class="input-box-date">
                    <input type="text" id="_laydayend" name="dayend" readonly="readonly" placeholder="请选择结束时间">
                </div>
            </div>
            <div class="search-submit">
                <a href="javascript:" @click="submitData">查询</a>
            </div>
        </div>
        <div class="table-box">
            <v-table :ajaxData="tableData" :newAdd="'名字'"></v-table>
        </div>
    </div>
</template>

<script>
    import VTable from './table/table';
    import {listen,set_start,set_end} from "./table/ajax.js"
    import {mapGetters,mapActions} from "vuex";

    var _now = new Date();
    var _default_option = {
                    start_min: {
                        year: 1970,
                        month: 0,
                        date: 1,
                    },
                    start_max: {
                        'date': {
                            'year': _now.getFullYear(),
                            'month': 0,
                            'date': _now.getDate()
                        },
                        'month': {
                            'year': _now.getFullYear(),
                            'month': _now.getMonth()
                        },
                        'year': {
                            'year': _now.getFullYear()
                        }
                    },
                    end_min: {
                        year: 1970,
                        month: 0,
                        date: 1,
                    },
                    end_max: {
                        'date': {
                            'year': _now.getFullYear(),
                            'month': _now.getMonth(),
                            'date': _now.getDate()
                        },
                        'month': {
                            'year': _now.getFullYear(),
                            'month': _now.getMonth()
                        },
                        'year': {
                            'year': _now.getFullYear()
                        }
                    },
                }
    export default {
        name:"lively-resource",
        data(){
            return {
                isShow:false,
                prevShow:-1,
                mediumCont:"请选择事件类型",
                mediumList:{"0":"全部","1":"登录","2":"注册","3":"分享","4":"预约"},
                mediumKey:0,
                selectRange:[
                    {name:"day",id:"date",txt:"天"},
                    {name:"month",id:"month",txt:"月"},
                    {name:"year",id:"year",txt:"年"},
                ],
                // 时间类型
                rangeVal:'date',
                // 遍历表格的数据
                tableData:"",
                _start_laydate:"",
                _end_laydate:"",
                dataType : {
                    "date": 'yyyy-MM-dd',
                    "month": 'yyyy-MM',
                    "year": 'yyyy',
                }
            }
        },
        mounted(){
            // 天数选择
            //常规用法
            let _this = this;
            
            var type = this.rangeVal;
            var $start_date = $("#_laydaystart"),$end_date = $("#_laydayend");
            this._start_laydate = laydate.render({
                elem: "#_laydaystart",
                max: 0,
                type: type,
                format: 'yyyy-MM-dd',
                showBottom: true,
                btns:["clear"],
                done: function (value, date, endDate) {
                    // 当前,内容,时间,{},时间类型,设置元素,当前时间
                    set_start($start_date,value, date, endDate,_this.rangeVal,_this._end_laydate,_now,true)
                    if ($start_date.val() == ''){
                        _this._end_laydate.config.min = _default_option['end_min'];
                        _this._end_laydate.config.max = _default_option['end_max'][_this.rangeVal];
                    }
                },
                change: function (value,date,endDate) {
                    $start_date.val(value,date);
                    set_start($start_date,value, date, endDate,_this.rangeVal,_this._end_laydate,_now,true)
                    $('.layui-laydate-list').on('click', 'li', function () {
                        $('.layui-laydate').hide();
                    });
                    if ($start_date.val() == ''){
                        _this._end_laydate.config.min = _default_option['end_min'];
                        _this._end_laydate.config.max = _default_option['end_max'][_this.rangeVal];
                    }
                }
            });
            this._end_laydate = laydate.render({
                elem: "#_laydayend",
                type: type,
                max: 0,
                format: 'yyyy-MM-dd',
                showBottom: true,
                btns:["clear"],
                done: function (value, date, endDate) {
                    set_end($end_date,value, date, endDate,_this.rangeVal,_this._start_laydate,true);
                    if ($end_date.val() == ''){
                        _this._start_laydate.config.min = _default_option['end_min'];
                        _this._start_laydate.config.max = _default_option['end_max'][_this.rangeVal];
                    }
                },
                change: function (value,date,endDate) {
                    set_end($end_date,value, date, endDate,_this.rangeVal,_this._start_laydate,true);
                    $end_date.val(value,date);
                    $('.layui-laydate-list').on('click', 'li', function () {
                        $('.layui-laydate').hide();
                    });
                    if ($end_date.val() == ''){
                        _this._start_laydate.config.min = _default_option['start_min'];
                        _this._start_laydate.config.max = _default_option['start_max'][_this.rangeVal];
                    }
                }
            });
            // 点击body 隐藏多选框
            document.body.addEventListener('click',function(){ 
                this.isShow = this.prevShow =  false;
            });
            // 异步更新数据
            $.ajax({
                url:webUrl+"/active/getOperateData",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                data:{
                    operate:"",
                    type:"",
                    start_time:"",
                    end_time:""
                },
                dataType:"JSON",
                success(res){
                    _this.tableData = res.data;
                }
            })
        },
        watch:{
            "rangeVal":function(val){
                $("#_laydaystart").val('');
                $("#_laydayend").val('');
                this._start_laydate.config.type = val;
                this._end_laydate.config.type = val;
                this._start_laydate.config.format = this.dataType[val];
                this._end_laydate.config.format = this.dataType[val];

                this._end_laydate.config.min = _default_option['end_min'];
                this._end_laydate.config.max = _default_option['end_max'][val];
                this._start_laydate.config.min = _default_option['start_min'];
                this._start_laydate.config.max = _default_option['start_max'][val];
            }
        },
        methods:{
            ...mapActions(['setHint']),
            copyMedium(event,val){
                this.mediumCont = val.el;
                this.mediumKey = val.key;
                this.isShow = false;
            },
            // 提交数据 更新现有数据
            submitData(){
                if(!localStorage.getItem("token")){
                    this.$router.push({path:"/"});
                    return ;
                }
                let startTime = document.querySelector("#_laydaystart").value;
                let endTime = document.querySelector("#_laydayend").value;
                let data = {
                    operate:this.mediumKey,
                    type:this.rangeVal,
                    start_time:startTime,
                    end_time:endTime
                }
                let _this = this;
                $.ajax({
                    url:webUrl+"/active/getOperateData",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:data,
                    dataType:"JSON",
                    success:function(res){
                        _this.setHint({txt:"请求成功",className:"hint-success"})
                        _this.tableData = res.data;
                        
                    }
                })
            }
        },
        components:{
            VTable:VTable
        }
    }
</script>

<style scoped>
.search-submit a {
    transition-duration: 600ms;
}
</style>




// WEBPACK FOOTER //
// src/components/main/affairAnalyze.vue